module.exports = __webpack_public_path__ + "static/pinkfloral1-cdbe121eb03af7146ef0f1ec98bb255b.png";